import "./stream.css";
import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/free-solid-svg-icons";

/* ── Pulsing LIVE dot ── */
function LiveDot() {
  const [on, setOn] = useState(true);
  useEffect(() => {
    const t = setInterval(() => setOn(v => !v), 900);
    return () => clearInterval(t);
  }, []);
  return (
    <span style={{
      display: "inline-block",
      width: 8, height: 8, borderRadius: "50%",
      background: on ? "#ff3a3a" : "transparent",
      boxShadow: on ? "0 0 8px #ff3a3a" : "none",
      transition: "all .9s ease",
      flexShrink: 0,
    }} />
  );
}

/* ── Animated viewer count ── */
function ViewerCount() {
  const [count, setCount] = useState(Math.floor(Math.random() * 4000 + 800));
  useEffect(() => {
    const t = setInterval(() => setCount(v => Math.max(100, v + Math.floor(Math.random() * 9) - 4)), 3000);
    return () => clearInterval(t);
  }, []);
  return <span>{count.toLocaleString()}</span>;
}

/* ── Single Live Card ── */
function LiveCard({ item, index }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        animation: `cardIn .55s ease both`,
        animationDelay: `${index * 0.09}s`,
      }}
    >
      <Link
        state={{ img: item.img, url: item.url, name: item.name }}
        to="/Live"
        style={{ textDecoration: "none" }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div style={{
          borderRadius: 20,
          overflow: "hidden",
          background: "linear-gradient(160deg,#0f1e14,#0a150d)",
          border: hovered
            ? "1px solid rgba(74,222,128,.45)"
            : "1px solid rgba(255,255,255,.07)",
          boxShadow: hovered
            ? "0 20px 50px rgba(0,0,0,.6), 0 0 0 1px rgba(74,222,128,.2), inset 0 0 30px rgba(74,222,128,.04)"
            : "0 6px 24px rgba(0,0,0,.45)",
          transform: hovered ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)",
          transition: "all .32s cubic-bezier(.22,1,.36,1)",
          cursor: "pointer",
          position: "relative",
        }}>

          {/* Thumbnail */}
          <div style={{ position: "relative", overflow: "hidden", aspectRatio: "16/9" }}>
            {item.logo
              ? <img
                  src={item.logo}
                  alt={item.name}
                  style={{
                    width: "100%", height: "100%", objectFit: "cover",
                    transform: hovered ? "scale(1.08)" : "scale(1)",
                    transition: "transform .5s ease",
                    display: "block",
                  }}
                />
              : (
                <div style={{
                  width: "100%", height: "100%",
                  background: "linear-gradient(135deg,#0d2b14,#1a4a22)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 52,
                }}>
                  🦛
                </div>
              )
            }

            {/* Dark overlay */}
            <div style={{
              position: "absolute", inset: 0,
              background: hovered
                ? "linear-gradient(to top, rgba(0,0,0,.75) 0%, rgba(0,0,0,.1) 60%)"
                : "linear-gradient(to top, rgba(0,0,0,.6) 0%, rgba(0,0,0,.05) 55%)",
              transition: "background .3s",
            }} />

            {/* LIVE badge */}
            <div style={{
              position: "absolute", top: 12, left: 12,
              display: "flex", alignItems: "center", gap: 6,
              background: "rgba(0,0,0,.72)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,60,60,.4)",
              borderRadius: 100,
              padding: "4px 10px",
              fontSize: 11, fontWeight: 800, color: "#fff",
              letterSpacing: ".14em",
              fontFamily: "'JetBrains Mono', monospace",
            }}>
              <LiveDot />
              LIVE
            </div>

    

            {/* Play button overlay on hover */}
            <div style={{
              position: "absolute", inset: 0,
              display: "flex", alignItems: "center", justifyContent: "center",
              opacity: hovered ? 1 : 0,
              transition: "opacity .25s",
            }}>
              <div style={{
                width: 52, height: 52, borderRadius: "50%",
                background: "rgba(255,255,255,.15)",
                backdropFilter: "blur(12px)",
                border: "2px solid rgba(255,255,255,.4)",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 20,
                transform: hovered ? "scale(1)" : "scale(.7)",
                transition: "transform .3s ease",
              }}>
                ▶
              </div>
            </div>
          </div>

          {/* Card footer */}
          <div style={{
            padding: "14px 16px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            gap: 10,
          }}>
            <div>
              <div style={{
                fontFamily: "'Sarabun', sans-serif",
                fontSize: 15, fontWeight: 700, color: "#fff",
                letterSpacing: ".01em",
                marginBottom: 3,
              }}>
                {item.name || "Live Stream"}
              </div>
              <div style={{
                fontSize: 11, color: "rgba(255,255,255,.38)",
                fontFamily: "'JetBrains Mono', monospace",
              }}>
                สวนสัตว์เปิดเขาเขียว
              </div>
            </div>
            <div style={{
              width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
              background: hovered
                ? "linear-gradient(135deg,#16a34a,#4ade80)"
                : "rgba(255,255,255,.07)",
              border: hovered ? "none" : "1px solid rgba(255,255,255,.1)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, color: hovered ? "#fff" : "rgba(255,255,255,.5)",
              transition: "all .28s ease",
              boxShadow: hovered ? "0 4px 14px rgba(74,222,128,.4)" : "none",
            }}>
              <FontAwesomeIcon icon={faVideo} />
            </div>
          </div>

          {/* Bottom accent line */}
          <div style={{
            position: "absolute", bottom: 0, left: 0, right: 0,
            height: 2,
            background: hovered
              ? "linear-gradient(90deg, #16a34a, #4ade80, #86efac)"
              : "transparent",
            transition: "background .3s",
          }} />
        </div>
      </Link>
    </div>
  );
}

/* ── Skeleton loader ── */
function SkeletonCard() {
  return (
    <div style={{
      borderRadius: 20, overflow: "hidden",
      background: "linear-gradient(160deg,#0f1e14,#0a150d)",
      border: "1px solid rgba(255,255,255,.06)",
    }}>
      <div style={{
        aspectRatio: "16/9",
        background: "linear-gradient(90deg,#1a2e1e 25%,#213827 50%,#1a2e1e 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.6s infinite linear",
      }} />
      <div style={{ padding: "14px 16px", display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ height: 15, width: "60%", borderRadius: 8, background: "#1a2e1e", animation: "shimmer 1.6s infinite linear", backgroundSize: "200% 100%" }} />
        <div style={{ height: 11, width: "40%", borderRadius: 8, background: "#162518", animation: "shimmer 1.6s .2s infinite linear", backgroundSize: "200% 100%" }} />
      </div>
    </div>
  );
}

/* ── MAIN ── */
function VDOLive() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetch("https://www.addpay.co.th/service-ui/service-my-zoo-admin/live.php")
      .then(r => r.json())
      .then(result => { setData(result); setLoading(false); })
      .catch(err => { console.error(err); setLoading(false); });
  }, []);

  const filtered = data.filter(item =>
    !search || (item.name || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@400;600;700;800&family=JetBrains+Mono:wght@400;600&family=Chakra+Petch:wght@600;700&display=swap');

        @keyframes cardIn {
          from { opacity:0; transform:translateY(24px) scale(.97); }
          to   { opacity:1; transform:translateY(0)    scale(1);   }
        }
        @keyframes shimmer {
          from { background-position: 200% 0; }
          to   { background-position:-200% 0; }
        }
        @keyframes heroFloat {
          0%,100% { transform:translateY(0); }
          50%     { transform:translateY(-6px); }
        }
        @keyframes gridScroll {
          from { background-position:0 0; }
          to   { background-position:60px 60px; }
        }
        @keyframes fadeIn {
          from { opacity:0; }
          to   { opacity:1; }
        }
        @keyframes scanLine {
          from { transform:translateY(-100%); }
          to   { transform:translateY(110vh); }
        }
        .search-input:focus { outline:none; border-color:rgba(74,222,128,.55)!important; box-shadow:0 0 0 3px rgba(74,222,128,.12)!important; }
        .search-input::placeholder { color:rgba(255,255,255,.28); }
      `}</style>

      <div style={{ minHeight: "100vh", background: "#070e09", color: "#fff", fontFamily: "'Sarabun', sans-serif" }}>
        <Navbar />

        {/* ── HERO HEADER ── */}
        <div style={{
          position: "relative", overflow: "hidden",
          padding: "72px 24px 60px",
          textAlign: "center",
        }}>
          {/* Animated grid bg */}
          <div style={{
            position: "absolute", inset: 0, zIndex: 0, pointerEvents: "none",
            backgroundImage: "linear-gradient(rgba(74,222,128,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(74,222,128,.04) 1px,transparent 1px)",
            backgroundSize: "60px 60px",
            animation: "gridScroll 12s linear infinite",
          }} />

          {/* Glow blobs */}
          <div style={{
            position: "absolute", top: "10%", left: "20%",
            width: 500, height: 300, borderRadius: "50%", zIndex: 0, pointerEvents: "none",
            background: "radial-gradient(circle, rgba(22,163,74,.14) 0%, transparent 70%)",
          }} />
          <div style={{
            position: "absolute", bottom: "5%", right: "15%",
            width: 350, height: 250, borderRadius: "50%", zIndex: 0, pointerEvents: "none",
            background: "radial-gradient(circle, rgba(134,239,172,.08) 0%, transparent 70%)",
          }} />

          {/* Scanline */}
          <div style={{ position: "absolute", inset: 0, zIndex: 1, pointerEvents: "none", overflow: "hidden", opacity: .025 }}>
            <div style={{ width: "100%", height: 160, background: "linear-gradient(transparent,rgba(255,255,255,.8),transparent)", animation: "scanLine 8s linear infinite" }} />
          </div>

          <div style={{ position: "relative", zIndex: 5 }}>
            {/* Live tag */}
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(220,38,38,.12)",
              border: "1px solid rgba(220,38,38,.35)",
              borderRadius: 100, padding: "5px 16px",
              marginBottom: 20,
              fontSize: 11, fontWeight: 700,
              color: "#fca5a5",
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: ".16em",
              animation: "fadeIn .6s ease",
            }}>
              <span style={{
                width: 7, height: 7, borderRadius: "50%",
                background: "#ef4444",
                boxShadow: "0 0 10px #ef4444",
                display: "inline-block",
              }} />
              LIVE NOW
            </div>

            {/* Title */}
            <h1 style={{
              fontFamily: "'Chakra Petch', sans-serif",
              fontSize: "clamp(28px, 6vw, 58px)",
              fontWeight: 700,
              lineHeight: 1.1,
              marginBottom: 16,
              background: "linear-gradient(135deg, #fff 0%, #86efac 50%, #4ade80 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              animation: "fadeIn .7s .1s both",
            }}>
              Live Streaming
            </h1>

            <p style={{
              fontSize: "clamp(13px, 2.2vw, 17px)",
              color: "rgba(255,255,255,.5)",
              maxWidth: 480,
              margin: "0 auto 32px",
              lineHeight: 1.7,
              animation: "fadeIn .7s .2s both",
            }}>
              รับชมไลฟ์สดจากสวนสัตว์แบบเรียลไทม์<br />ติดตามชีวิตสัตว์น่ารักตลอด 24 ชั่วโมง
            </p>

            {/* Stats row */}
            <div style={{
              display: "flex", justifyContent: "center", gap: 32, flexWrap: "wrap",
              marginBottom: 36,
              animation: "fadeIn .7s .3s both",
            }}>
              {[
                { label: "ช่องไลฟ์", value: loading ? "—" : data.length },
                { label: "กำลังออนไลน์", value: "24/7" },
                { label: "ผู้ชมเฉลี่ย", value: "8.4K" },
              ].map(s => (
                <div key={s.label} style={{ textAlign: "center" }}>
                  <div style={{
                    fontFamily: "'Chakra Petch', sans-serif",
                    fontSize: "clamp(22px, 4vw, 32px)", fontWeight: 700,
                    color: "#4ade80",
                    lineHeight: 1,
                  }}>{s.value}</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,.38)", marginTop: 4, fontFamily: "'JetBrains Mono', monospace" }}>
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Search */}
            <div style={{
              maxWidth: 380, margin: "0 auto",
              position: "relative",
              animation: "fadeIn .7s .4s both",
            }}>
              <span style={{
                position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
                fontSize: 16, pointerEvents: "none", opacity: .45,
              }}>🔍</span>
              <input
                className="search-input"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="ค้นหาไลฟ์..."
                style={{
                  width: "100%", padding: "12px 16px 12px 42px",
                  borderRadius: 12, border: "1px solid rgba(255,255,255,.1)",
                  background: "rgba(255,255,255,.05)",
                  backdropFilter: "blur(12px)",
                  color: "#fff", fontSize: 14,
                  fontFamily: "'Sarabun', sans-serif",
                  transition: "border-color .2s, box-shadow .2s",
                }}
              />
            </div>
          </div>
        </div>

        {/* ── CARDS GRID ── */}
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 20px 80px" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: 22,
          }}>
            {loading
              ? [...Array(6)].map((_, i) => <SkeletonCard key={i} />)
              : filtered.length > 0
                ? filtered.map((item, i) => <LiveCard key={i} item={item} index={i} />)
                : (
                  <div style={{
                    gridColumn: "1/-1", textAlign: "center",
                    padding: "80px 20px", color: "rgba(255,255,255,.35)",
                  }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
                    <div style={{ fontFamily: "'Chakra Petch', sans-serif", fontSize: 18 }}>
                      ไม่พบไลฟ์ที่ค้นหา
                    </div>
                  </div>
                )
            }
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default VDOLive;
